import React, { Component } from 'react';
import { Modal, Input, Button, message } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

const { TextArea } = Input;

class RequireRemark extends Component {
    state = {
        visible: false,
        loading: false,
        requirementDescribe: undefined,
        editable: false,
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.member.queryByInvId,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { requirementDescribe } = res.data || {};
                this.setState({
                    loading: false,
                    requirementDescribe,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    show = (editable) => {
        this.setState({
            visible: true,
            requirementDescribe: undefined,
            editable,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (e) => {
        this.setState({ requirementDescribe: e.target.value });
    }

    handleSubmit = () => {
        const { requirementDescribe } = this.state;
        if (!requirementDescribe) {
            message.warning("备注内容不能为空");
            return;
        }
        this.setState({ loading: true });
        const options = {
            url: API_URL.member.saveInvReq,
            data: {
                requirementDescribe,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, loading, editable, requirementDescribe } = this.state;
        const settings = {};
        if (editable) {
            settings.onOk = this.handleSubmit;
        } else {
            settings.footer = <Button type="ghost" onClick={this.hide}>关闭</Button>;
        }
        return (
            <Modal
                title="项目需求描述"
                visible={visible}
                onCancel={this.hide}
                width="480px"
                loading={loading}
                maskClosable={false}
                {...settings}
            >
                <div>
                    <div style={{ marginBottom: 10 }}>
                        {editable && '请描述'}
                        本项目需要的人员要求：
                    </div>
                    <div>
                        {
                            editable ?
                                <TextArea placeholder='请输入' value={requirementDescribe} rows={6} onChange={this.handleChange} />
                            :
                                <div style={{ whiteSpace: 'pre-wrap' }}>{requirementDescribe}</div>
                        }
                    </div>
                </div>
            </Modal>
        );
    }
}

export default RequireRemark;


// WEBPACK FOOTER //
// ./src/components/user/require/components/RequireRemark.js